import { Component, Output, EventEmitter, Input } from '@angular/core';
import { DisplayableInTree } from '../../core-data-model/DisplayableInTree';
import { Folder } from '../../core-data-model/Folder.model';
import { FoldersDataService } from '../../core-services/Folders.dataservice';
import { TranslationService } from '../../translations';

@Component({
    selector: 'folder-select-modal',
    template: `
        <modal class="pi-modal">
            <div class="pi-modalHeader">
                <span class="flex-1">
                    {{ TR.key('folderManagement.moveFolderModal-header') }}
                </span>
                <!-- DO NOT make the (mousedown) a (click) it will break this
            modal from working for some weird reason-->
                <button
                    type="button"
                    class="close"
                    (mousedown)="closeModal()"
                    [title]="TR.key('text.common-terms.close')"
                >
                    <i
                        class="fa fa-close"
                        [title]="TR.key('text.common-terms.close')"
                    ></i>
                </button>
            </div>
            <div class="pi-modalSubheader lsg-text3">
                {{ TR.key('WhichFolder') }}
            </div>
            <div class="pi-modalBody">
                <folder-tree-entry
                    class="pi-folder pi-folder--caretIcons"
                    [item]="foldersService.rootFolder"
                    (folderSelected)="setSelectedFolder($event)"
                    [options]="{
                        startOpen: true,
                        depthOpenUntil: 0
                    }"
                >
                    <ng-template #nodeDisplay let-item="item">{{
                        item.name
                    }}</ng-template>
                </folder-tree-entry>
            </div>
            <div class="pi-modalFooter">
                <div class="btn--lsg_centeredContainer">
                    <button
                        type="button"
                        class="btn btn--lsg"
                        (click)="closeModal()"
                    >
                        {{ TR.key('text.common-terms.cancel') }}
                    </button>
                    <button
                        type="button"
                        class="btn btn--lsg btn--lsg--primary"
                        (click)="done()"
                        [disabled]="!treeSelection"
                    >
                        {{ TR.key('text.common-terms.done') }}
                    </button>
                </div>
            </div>
        </modal>
    `,
    standalone: false
})
export class FolderSelectModalComponent {
    treeSelection: DisplayableInTree;

    @Input()
    folders: Folder[];

    @Output()
    readonly folderSelected = new EventEmitter();
    @Output()
    readonly modalClosed = new EventEmitter();

    constructor(
        public TR: TranslationService,
        public foldersService: FoldersDataService
    ) {}

    setSelectedFolder(item: DisplayableInTree) {
        this.treeSelection = item;
    }

    closeModal(): void {
        this.modalClosed.emit();
    }

    done(): void {
        this.folderSelected.emit(this.treeSelection);
    }
}
